var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletIconBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4059_85317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.011 15.0762C15.6665 16.2946 14.5039 15.5823 13.6323 15.5414C13.1164 15.5173 12.7916 15.9932 13.1198 16.3995C13.3157 16.642 14.1022 16.7481 14.4676 16.8041L14.6808 17.6328C15.684 17.8294 15.5304 17.6092 15.7308 16.7514C16.4486 16.5023 16.7738 16.3759 17.1158 15.8615C17.4944 15.2922 17.4604 14.6424 17.0555 14.0918C16.3417 13.1214 14.0906 13.0603 14.3831 12.1745C15.173 11.2024 16.1896 12.3029 16.8617 11.756C17.4088 10.9999 16.5178 10.8766 15.8277 10.7537L15.5416 9.92984C14.8694 9.84105 14.8702 9.90222 14.695 10.3474C14.3981 11.1014 14.962 10.6205 14.0146 11.0268C13.394 11.2931 12.9374 11.8065 13.0377 12.6521C13.2207 14.192 15.5351 13.814 16.0109 15.076L16.011 15.0762Z",
    fill: "#0B8376"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76517 5.5293C5.04526 7.44522 17.0348 7.13802 16.244 5.04964C15.6475 3.47454 8.00077 3.56363 5.50286 3.96615C4.36453 4.1495 2.73748 4.41683 2.76524 5.5293H2.76517Z",
    fill: "#9BE5C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62397 10.4223C9.06757 9.31817 9.804 8.70544 10.4431 8.05887C8.20022 7.93859 6.74077 8.08428 4.4571 7.52062C3.82977 7.36581 3.35802 7.00414 2.7771 6.97363C2.37921 9.14699 2.75077 9.48455 4.45451 9.91818C5.79864 10.2602 7.1843 10.3683 8.62397 10.4223Z",
    fill: "#0B8376"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71614 16.4399C4.0077 17.3428 6.86552 17.8711 8.8359 17.7014C8.50269 16.9458 8.07149 16.2647 7.97312 15.3048C7.05289 15.2386 6.124 15.1729 5.23611 15.0006C4.54449 14.8662 3.12635 14.294 2.76886 14.3003L2.71606 16.4399L2.71614 16.4399Z",
    fill: "#0B8376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81443 11.8419L7.61017 13.8205C7.1474 13.8391 6.54439 13.7803 5.93729 13.6831C5.26414 13.5753 4.60111 13.4228 4.14502 13.2871L4.14501 13.2871C3.2828 13.0306 3.02101 12.7955 2.92239 12.4736C2.86783 12.2955 2.85726 12.0729 2.86551 11.7653C2.86847 11.6549 2.87399 11.5312 2.88002 11.3962C2.88732 11.2328 2.89536 11.0529 2.90049 10.8599C2.98283 10.8818 3.08434 10.9112 3.2068 10.9468C3.22137 10.9511 3.23621 10.9554 3.25131 10.9598C3.51694 11.0372 3.86573 11.1389 4.29204 11.247C5.15708 11.4664 6.34107 11.7124 7.81443 11.8419Z",
    fill: "#9BE5C9",
    stroke: "#9BE5C9",
    strokeWidth: 0.370022
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0299 19.3571C18.0658 19.3571 20.5419 16.8811 20.5419 13.8451C20.5419 10.8092 18.0658 8.33301 15.0299 8.33301C11.994 8.33301 9.51782 10.8091 9.51782 13.8451C9.51782 16.881 11.9939 19.3571 15.0299 19.3571Z",
    fill: "#9BE5C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3978 14.6182H17.6621C17.8736 14.6182 18.0467 14.7912 18.0467 15.0027V15.1952C18.0467 15.4068 17.8736 15.5798 17.6621 15.5798H12.3978C12.1862 15.5798 12.0132 15.4067 12.0132 15.1952V15.0027C12.0132 14.7912 12.1862 14.6182 12.3978 14.6182Z",
    fill: "#9BE5C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3978 12.9771H17.6621C17.8736 12.9771 18.0467 13.1501 18.0467 13.3616V13.554C18.0467 13.7656 17.8736 13.9386 17.6621 13.9386H12.3978C12.1862 13.9386 12.0132 13.7656 12.0132 13.554V13.3616C12.0132 13.1501 12.1862 12.9771 12.3978 12.9771Z",
    fill: "#9BE5C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9135 20.2835C18.4687 20.2835 21.3685 17.3839 21.3685 13.8285C21.3685 10.2732 18.4687 7.37354 14.9135 7.37354C11.3582 7.37354 8.4585 10.2733 8.4585 13.8285C8.4585 17.3839 11.3582 20.2835 14.9135 20.2835Z",
    fill: "#0B8376"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3409 14.584H17.4861C17.6928 14.584 17.8619 14.7532 17.8619 14.9599V15.1479C17.8619 15.3546 17.6928 15.5238 17.4861 15.5238H12.3409C12.1342 15.5238 11.9651 15.3546 11.9651 15.1479V14.9599C11.9651 14.7532 12.1342 14.584 12.3409 14.584Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3409 12.9805H17.4861C17.6928 12.9805 17.8619 13.1496 17.8619 13.3564V13.5443C17.8619 13.7511 17.6928 13.9202 17.4861 13.9202H12.3409C12.1342 13.9202 11.9651 13.7511 11.9651 13.5443V13.3564C11.9651 13.1496 12.1342 12.9805 12.3409 12.9805Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4059_85317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIconBalance);
export default __webpack_public_path__ + "static/media/wallet-icon-balance.6e9153a480c438c4b044d1b8ed419377.svg";
export { ForwardRef as ReactComponent };